/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChildTrackingInfo } from './childTrackingInfo';
import { ChildInternalPropertiesModel } from './childInternalPropertiesModel';
import { ConnectedUserRoleEnum } from './connectedUserRoleEnum';
import { ChildNotificationOptionsModel } from './childNotificationOptionsModel';
import { ChildShiftWorkProperties } from './childShiftWorkProperties';
import { AuthTypeEnum } from './authTypeEnum';
import { ApiResponseAuthRefreshModel } from './apiResponseAuthRefreshModel';
import { ChildCommuteDataModel } from './childCommuteDataModel';


export interface ApiResponseSignupUserModel { 
    connectedEmployerRole: ConnectedUserRoleEnum;
    authType: AuthTypeEnum;
    username: string;
    connectedToEmployer: string;
    displayName?: string | null;
    email: string;
    phoneNumber: string;
    pushNotificationToken: string;
    internalProperties: ChildInternalPropertiesModel;
    notificationOptions: ChildNotificationOptionsModel;
    addresses: object;
    commuteData: ChildCommuteDataModel;
    trackingInfo: ChildTrackingInfo;
    shiftWorkProperties: ChildShiftWorkProperties | null;
    pendingJoinRequestAtEmployer?: string;
    isNewUser: boolean;
    authResponse?: ApiResponseAuthRefreshModel;
}



